export const LS_REFERRAL_CODE_KEY = "ref_code";
